import React from 'react';
import { Grid } from '@material-ui/core';
import targets from '../../images/targets/targets.png';
import getSafeSpacing from '../../common/getSafeSpacing';
import img1 from '../../images/targets/1.jpg';
import img2 from '../../images/targets/2.jpg';
import img3 from '../../images/targets/3.jpg';
import img4 from '../../images/targets/4.png';
import img5 from '../../images/targets/5.png';
import img6 from '../../images/targets/6.png';
import img7 from '../../images/targets/7.png';
import img8 from '../../images/targets/8.png';
import img9 from '../../images/targets/9.png';

const TargetsPage = () => (
  <>
    <img src={targets} style={{ width: '100%' }} alt="줄눈시공대상" />
    <div style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}>
      <span
        className="noselect"
        style={{ fontSize: '25px', fontWeight: 'bolder' }}
      >
        줄눈시공 대상 : 욕실화장실 바닥, 벽면시공, 욕실, 샤워부스,
        욕조테두리
        <br />
        {' '}
        베란다, 세탁실, 현관바닥, 폴리싱타일, 아트홀, 전시장
      </span>
    </div>
    <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
      spacing={getSafeSpacing(3)}
    >
      <Grid item xs={12} lg={4}>
        <img src={img1} className="galleryImage" alt="욕실바닥" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img2} className="galleryImage" alt="욕실벽" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img3} className="galleryImage" alt="현관" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img4} className="galleryImage" alt="관공서" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img5} className="galleryImage" alt="식당" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img6} className="galleryImage" alt="전시장" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img7} className="galleryImage" alt="관공서" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img8} className="galleryImage" alt="화장실" />
      </Grid>
      <Grid item xs={12} lg={4}>
        <img src={img9} className="galleryImage" alt="아트홀" />
      </Grid>
    </Grid>
  </>
);

export default TargetsPage;
